import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

interface SuggestionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const SuggestionModal = ({
  open,
  onOpenChange,
}: SuggestionModalProps) => {
  const [suggestion, setSuggestion] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!suggestion.trim()) {
      return;
    }

    setIsSubmitting(true);

    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setIsSubmitting(false);
    setSuggestion("");
    onOpenChange(false);

    toast.success("Thanks for your suggestion!", {
      description: "Our team will review it.",
    });
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setSuggestion("");
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="w-[80%] max-w-lg rounded-2xl">
        <DialogHeader className="text-left">
          <DialogTitle>Suggest a new agent</DialogTitle>
          <DialogDescription>
            Tell us what you'd like Stacey to help you with
          </DialogDescription>
        </DialogHeader>
        <div>
          <Textarea
            placeholder="Describe the agent you'd like us to build..."
            value={suggestion}
            onChange={(e) => setSuggestion(e.target.value)}
            className="min-h-[120px] resize-none"
            disabled={isSubmitting}
          />
        </div>
        <DialogFooter className="flex-row justify-end gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleSubmit}
            disabled={!suggestion.trim() || isSubmitting}
            isLoading={isSubmitting}
          >
            Submit suggestion
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
